import { ArrowRight, CircleCheck, CircleDashed, Loader2 } from "lucide-react";
import * as React from "react";

import { Dialog } from "@/components/ui";

export function EditorSubmitEventDialog({
  open,
  onOpenChange,
  onSubmitForQa,
  onComplete,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmitForQa: () => void;
  onComplete: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange} size="md" showCloseButton>
      <Dialog.Header className="border-b-0 pb-1">
        <Dialog.Title>Submit edit</Dialog.Title>
        <Dialog.Description>How should this project move forward?</Dialog.Description>
      </Dialog.Header>
      <Dialog.Content className="flex flex-col gap-2.5 pt-1">
        <button
          type="button"
          onClick={onSubmitForQa}
          className="group flex w-full cursor-pointer items-start gap-3 rounded-xl border border-slate-200 bg-white p-4 text-left transition-all hover:border-indigo-300 hover:bg-indigo-50/60 hover:shadow-sm"
        >
          <span className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-indigo-50 text-indigo-500 transition-colors group-hover:bg-indigo-100">
            <CircleDashed className="size-5" />
          </span>
          <span className="flex min-w-0 flex-1 flex-col gap-0.5">
            <span className="text-sm font-semibold text-slate-800">Submit for QA Review</span>
            <span className="text-xs leading-relaxed text-slate-500">
              A reviewer will check this cut before it goes live.
            </span>
          </span>
          <ArrowRight className="mt-2.5 size-4 shrink-0 text-slate-300 transition-all group-hover:translate-x-0.5 group-hover:text-indigo-500" />
        </button>
        <button
          type="button"
          onClick={onComplete}
          className="group flex w-full cursor-pointer items-start gap-3 rounded-xl border border-slate-200 bg-white p-4 text-left transition-all hover:border-emerald-300 hover:bg-emerald-50/60 hover:shadow-sm"
        >
          <span className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-emerald-50 text-emerald-500 transition-colors group-hover:bg-emerald-100">
            <CircleCheck className="size-5" />
          </span>
          <span className="flex min-w-0 flex-1 flex-col gap-0.5">
            <span className="text-sm font-semibold text-slate-800">Complete</span>
            <span className="text-xs leading-relaxed text-slate-500">Mark it done and ready to post.</span>
          </span>
          <ArrowRight className="mt-2.5 size-4 shrink-0 text-slate-300 transition-all group-hover:translate-x-0.5 group-hover:text-emerald-500" />
        </button>
      </Dialog.Content>
    </Dialog>
  );
}

export function EditorSubmittingDialog({ open }: { open: boolean }) {
  return (
    <Dialog open={open} onOpenChange={undefined} size="sm" disableEscapeDismissal={true}>
      <Dialog.Header>
        <Dialog.Title className="flex items-center gap-1.5 text-slate-800 text-sm font-semibold select-none">
          <Loader2 className="animate-spin size-4 text-indigo-600 shrink-0" />
          <span>Submitting Project</span>
        </Dialog.Title>
      </Dialog.Header>

      <Dialog.Content className="p-5 flex flex-col items-center justify-center gap-4 text-center">
        <div className="text-xs text-slate-600 font-medium">
          Please wait while we submit your video project changes. This may take a few moments.
        </div>
      </Dialog.Content>
    </Dialog>
  );
}
